import { RuleObject } from 'antd/lib/form';
import i18n from 'i18n';

const dniValidator = (rule: RuleObject, value: string): Promise<void> => {
  if (/^(?!^0+$)[a-zA-Z0-9]{6,9}$/.test(value)) {
    return Promise.resolve();
  }
  return Promise.reject(new Error(i18n.t('validation.invalidDni')));
};
export default dniValidator;
